import { io, type Socket } from 'socket.io-client';

const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
const isRelative = API_BASE.startsWith('/');

let socketInstance: Socket | null = null;

export function getSocket(): Socket | null {
  return socketInstance;
}

export function connectSocket(accessToken: string): Socket {
  if (socketInstance) {
    socketInstance.disconnect();
  }
  socketInstance = io(isRelative ? window.location.origin : API_BASE, {
    path: isRelative ? `${API_BASE}/socket.io` : '/socket.io',
    auth: { token: accessToken },
    withCredentials: true,
    transports: ['websocket', 'polling'],
  });
  return socketInstance;
}

export function disconnectSocket(): void {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
}
